<template>
  <div :id="id + 'Accordion'" class="list">
    <!-- 리스트 출력 -->
    <ul v-if="!loaderActive && itemList.length > 0">
      <li v-for="item in itemList" :key="id + item.id">
        <div class="panel-wrap">
          <div class="panel-content">
            <a class="panel-header" data-toggle="collapse" :href="'#' + id + item.id">
              <div v-if="useCategory" class="category">{{ item.category }}</div>
              <div v-if="useDate" class="date">{{ item.reg_date | formatDate }}</div>
              <h4 class="title">{{ item.title }}</h4>
            </a>
            <div :id="id + item.id" class="panel-collapse collapse">
              <div class="panel-body" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!-- Loader -->
    <div v-if="loaderActive" class="loader-wrap">
      <div class="loader-content">
        <bar-loader></bar-loader>
      </div>
    </div>
    <!-- 데이터가 없을 경우 메세지 출력 -->
    <div v-if="!loaderActive && itemList.length === 0" class="empty-message">{{ emptyMessage }}</div>
  </div>
</template>

<script>
  import BarLoader from 'common/components/BarLoader'

  export default {
    name: 'list',
    components: {
      BarLoader
    },
    props: {
      id: {
        type: String,
        default: function () {
          return 'item'
        }
      },
      itemList: {
        type: Array,
        default: function () {
          return []
        }
      },
      loaderActive: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      emptyMessage: {
        type: String,
        default: function () {
          return '데이터가 없습니다.'
        }
      },
      useCategory: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      useDate: {
        type: Boolean,
        default: function () {
          return false
        }
      }
    },
    data: function () {
      return {
      }
    },
    mounted: function () {
      // 컨텐츠 클릭 시 하나만 열리도록 이벤트 처리
      const el = $(this.$el)

      el.on('show.bs.collapse', '.collapse', function () {
        el.find('.collapse.in').collapse('hide')
      })
    }
  }
</script>

<style lang="scss" scoped>
  .list {
    ul {
      padding: 0;
      margin: 0;
      list-style: none;
    }

    p {
      margin: 0;
    }

    // Panel CSS
    .panel-content {
      border-bottom: 1px solid #adb5bd;
    }

    .panel-header {
      display: block;
      padding: 24px 0;
      cursor: pointer;

      .title {
        display: inline-block;
        max-width: calc(100% - 153px);
        margin: 0;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: -0.3px;
        color: $font-color;
        word-break: break-all;

        &:hover,
        &:focus {
          text-decoration: underline;
        }
      }

      .category {
        min-width: 153px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        font-size: 14px;
        line-height: 1.33;
        letter-spacing: -0.8px;
        color: #5f78a4;
        float: left;
      }

      .date {
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        font-size: 16px;
        line-height: 1.25;
        letter-spacing: -0.3px;
        color: #2e3134;
        float: right;
      }

      @media (max-width: 767px) {
        .title {
          display: block;
          max-width: initial;
        }

        .category, .date {
          float: initial;
        }
      }
    }

    .panel-body {
      background-color: #f3f4f8;
    }

    .loader-wrap {
      position: relative;
      min-height: 240px;
      padding: 40px 0;

      .loader-content {
        position: absolute;
        top: calc(50% - 20px);
        left: calc(50% - 32px);
        transform: translate(-50%, -50%);
      }
    }

    .empty-message {
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 200px;
      letter-spacing: -0.3px;
      text-align: center;
      color: #495057;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/List.vue